export default __webpack_public_path__ + "static/media/coupleStanding.a58a5ef0.jpg";